import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const HighlightText = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.25659 11.2092L12.6367 3.6621L15.8656 5.96392L10.4855 13.511L7.25659 11.2092ZM5.74493 10.7456C5.48451 11.1109 5.50471 11.5915 5.76252 11.9309L5.03559 12.9506C4.5554 13.6242 4.62041 14.5219 5.1426 15.1183L3.57465 17.199C3.32631 17.5286 3.56153 18.0001 3.97417 18L6.33305 17.999C6.49244 17.9989 6.64225 17.9229 6.73637 17.7942L7.47608 16.7832C8.21118 17.0851 9.08354 16.8543 9.56473 16.1793L10.2919 15.1592C10.6965 15.2915 11.1566 15.1537 11.4167 14.7889L17.3773 6.4275C17.6979 5.97778 17.5932 5.35333 17.1435 5.03274L13.1003 2.15045C12.6505 1.82986 12.0261 1.93454 11.7055 2.38425L5.74493 10.7456ZM6.95779 12.8383L9.0441 14.3256L8.34331 15.3086C8.26317 15.421 8.10705 15.4472 7.99462 15.3671L6.31546 14.17C6.20303 14.0899 6.17686 13.9338 6.25701 13.8213L6.95779 12.8383Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default HighlightText
